import { EndOfJourneyTemplate } from '../../lib/types/models/end-of-journey-template/end-of-journey-template'
import { EndOfJourneyTemplateInput } from '../../lib/types/models/end-of-journey-template/end-of-journey-template-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createEndOfJourneyTemplate(
  data: EndOfJourneyTemplateInput
): Promise<EndOfJourneyTemplate> {
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-templates'].create.url, null))
    .post<EndOfJourneyTemplate, EndOfJourneyTemplateInput>(data)
}
